export default __webpack_public_path__ + "static/media/blog6.54143851.png";